var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineGalleryEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8c0-1.52 1.23-2.75 2.75-2.75S11.75 6.48 11.75 8 10.52 10.75 9 10.75 6.25 9.52 6.25 8zm1.5 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h4c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.66 9.34c-.31-.31-.46-.77-.39-1.24l.2-1.39c.05-.35.26-.78.52-1.03l3.63-3.63c1.45-1.45 2.71-.62 3.33 0 .59.59.86 1.21.8 1.85-.05.51-.31 1-.8 1.48l-3.63 3.63c-.25.25-.68.46-1.03.52l-1.39.2c-.08.02-.16.02-.23.02-.39 0-.75-.14-1.01-.41zm1.38-2.59c-.03.03-.08.14-.09.19l-.19 1.3 1.31-.18c.04-.01.15-.06.19-.1l3.63-3.63c.22-.22.35-.42.36-.57.02-.21-.19-.47-.36-.64-.52-.52-.76-.46-1.22 0l-3.63 3.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 6.1a4.077 4.077 0 0 1-2.79-2.79c-.11-.4.12-.81.52-.92.4-.11.81.12.92.52.24.84.91 1.52 1.76 1.76.4.11.63.53.52.92a.79.79 0 0 1-.73.54c-.07 0-.14-.01-.2-.03zM2.05 19.37a.753.753 0 0 1 .2-1.04l4.93-3.31c1.08-.72 2.57-.64 3.55.19l.33.29c.5.43 1.35.43 1.84 0l4.16-3.57c1.06-.91 2.73-.91 3.8 0l1.63 1.4c.31.27.35.74.08 1.06-.27.31-.74.35-1.06.08l-1.63-1.4c-.5-.43-1.35-.43-1.84 0l-4.16 3.57c-1.06.91-2.73.91-3.8 0l-.33-.29c-.46-.39-1.22-.43-1.73-.08L3.1 19.58c-.14.08-.29.12-.43.12-.24 0-.48-.12-.62-.33z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGalleryEdit);
export default __webpack_public_path__ + "static/media/vuesax-outline-gallery-edit.ab539ebc73a1e46b3cd74fcea3fd29a1.svg";
export { ForwardRef as ReactComponent };